/* Hide zero-amount discount rows in the Essential cart drawer */
(function () {
  let timer;

  const hideZeroDiscounts = async () => {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());

      const zeroKeys = new Set(
        cart.items
          .filter((i) => {
            const allocs = i.line_level_discount_allocations || [];
            return allocs.length > 0 && allocs.every((a) => !a.amount);
          })
          .map((i) => i.key)
      );
      if (!zeroKeys.size) return;

      document
        .querySelectorAll('[data-essential-cart-element="cart-drawer-item"]')
        .forEach((item) => {
          const row = item.querySelector('[data-essential-cart-element="line-item-discounts"]');
          if (!row) return;

          const link = item.querySelector('a[href*="variant="]');
          if (!link) return;
          const variantId = new URL(link.href, location.origin).searchParams.get('variant');

          const match = cart.items.find((i) => String(i.variant_id) === variantId);
          if (match && zeroKeys.has(match.key)) row.style.display = 'none';
        });
    } catch (e) {
      /* silent */
    }
  };

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(hideZeroDiscounts, 300);
  };

  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('cart:update', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();